<script lang="ts">
import { defineComponent, h, Transition } from 'vue';

export default defineComponent({
    name: 'WidthTransition',

    setup(_, { attrs, slots }) {
        // When one element replaces another, such as a changing label, the old
        // one shrinks as the new one grows, on the same curve, so the width
        // moves smoothly between them. Both start in the frame they're updated,
        // as one starting later would make the width swell, then jump.
        return () =>
            h(
                Transition,
                {
                    name: 'width-transition',
                    ...attrs,
                    onBeforeEnter(el: Element) {
                        (el as HTMLElement).style.width = '0';
                    },
                    onEnter(el: Element) {
                        const element = el as HTMLElement;
                        element.style.width = `${element.scrollWidth}px`;
                    },
                    onAfterEnter(el: Element) {
                        (el as HTMLElement).style.width = '';
                    },
                    onLeave(el: Element) {
                        const element = el as HTMLElement;
                        element.style.width = `${element.offsetWidth}px`;
                        void element.offsetWidth;
                        element.style.width = '0';
                    },
                    onAfterLeave(el: Element) {
                        (el as HTMLElement).style.width = '';
                    },
                },
                slots,
            );
    },
});
</script>
